import React from "react";
import PropTypes from "prop-types";
import { Select, Textarea } from "rbx";
import { DateInput } from "../../../../components";

const getOptionSortValue = (option) => {
  const rawValue = option?.value;
  const numericValue = Number(rawValue);
  if (
    rawValue !== null &&
    rawValue !== undefined &&
    rawValue !== "" &&
    Number.isFinite(numericValue)
  ) {
    return { isNumeric: true, numericValue };
  }
  return {
    isNumeric: false,
    textValue: String(rawValue ?? option?.name ?? "").toLowerCase(),
  };
};

const sortAnswerOptions = (a, b) => {
  const aValue = getOptionSortValue(a);
  const bValue = getOptionSortValue(b);

  if (aValue.isNumeric && bValue.isNumeric) {
    return aValue.numericValue - bValue.numericValue;
  }
  if (aValue.isNumeric) return -1;
  if (bValue.isNumeric) return 1;

  return aValue.textValue.localeCompare(bValue.textValue);
};

const EvaluationQuestion = ({
  question,
  questionId,
  questionIndex,
  sectionIndex,
  isEvaluationCompleted,
  handleInputChange,
}) => {
  if (question.answerType === "date") {
    return (
      <div className="flex-list-item">
        <p>
          {questionIndex + 1}. {question?.text}
        </p>

        <div className="dropdown-container">
          <DateInput
            required
            disabled={isEvaluationCompleted}
            label=""
            name={`${sectionIndex}-${questionId}`}
            value={question?.answer}
            onChange={handleInputChange}
          />
        </div>
      </div>
    );
  }


  if (question.answerType === "multi") {
    return (
      <div className="flex-list-item">
        <p>
          {questionIndex + 1}. {question?.text}
        </p>
        <Select.Container className="dropdown-container">
          <Select
            required
            className="dropdown"
            disabled={isEvaluationCompleted}
            name={`${sectionIndex}-${questionId}`}
            value={question?.answer || ""}
            onChange={handleInputChange}
          >
            <Select.Option value="" />
            {[...question?.answerOptions]?.sort(sortAnswerOptions).map((option) => (
              <Select.Option key={option.id} value={option.value}>
                {option.name}
              </Select.Option>
            ))}
          </Select>
        </Select.Container>
      </div>
    );
  }

  return (
    <div className="text-input">
      <p>
        {questionIndex + 1}. {question?.text}
      </p>
      <div>
        <Textarea
          required
          disabled={isEvaluationCompleted}
          name={`${sectionIndex}-${questionId}`}
          placeholder="Enter response here"
          rows={2}
          value={question?.answer || ""}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};

EvaluationQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  questionId: PropTypes.string.isRequired,
  questionIndex: PropTypes.number.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  isEvaluationCompleted: PropTypes.bool.isRequired,
  handleInputChange: PropTypes.func.isRequired,
};

export default EvaluationQuestion;
